import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiBriefcase, FiCompass, FiCpu, FiTrendingUp } from 'react-icons/fi';

const milestones = [
  {
    title: 'Travel technology',
    description: 'Spent nearly a decade in travel technology, gaining firsthand exposure to how digital platforms and distribution systems change customer behaviour and commercial operations.',
    icon: <FiCompass className="w-6 h-6" />
  },
  {
    title: 'Entrepreneurship',
    description: 'Built businesses in travel and customer experience, learning what it takes to turn fragmented customer needs into repeatable operations.',
    icon: <FiBriefcase className="w-6 h-6" />
  },
  {
    title: 'Zakool AI',
    description: 'Moved into PropTech to address the growing gap between digital buyer behaviour and the disconnected systems behind real estate sales.',
    icon: <FiCpu className="w-6 h-6" />
  },
  {
    title: 'Building across markets',
    description: 'Today, the focus is building Zakool AI for real estate developers and brokerages across the UAE and India, with infrastructure designed to scale beyond individual channels or markets.',
    icon: <FiTrendingUp className="w-6 h-6" />
  }
];

const Journey = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section className="section-padding bg-off-white">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
        transition={{ duration: 0.6 }}
        className="container-custom"
      >
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14">
            <p className="text-sm uppercase tracking-[0.2em] text-gold font-semibold mb-3">Journey</p>
            <h2 className="text-4xl md:text-5xl font-serif text-navy mb-4">From digital travel to AI-native real estate sales.</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {milestones.map((milestone) => (
              <div key={milestone.title} className="bg-white rounded-xl p-7 border border-gray-100 shadow-sm">
                <div className="w-12 h-12 rounded-full border border-gold/50 flex items-center justify-center text-gold mb-5">
                  {milestone.icon}
                </div>
                <h3 className="text-xl font-serif text-navy mb-3">{milestone.title}</h3>
                <p className="text-charcoal leading-relaxed">{milestone.description}</p>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Journey;
